interface CardDetailsProps {
  recipient: "Consultor da concessionária" | "Volks|total" | "Gestor de Frotas" | "Não identificado";
  date: string;
}

const CardDetails = ({ recipient, date }: CardDetailsProps) => {
  return (
    <div className="space-y-2 mb-3">
      <div className="flex justify-between">
        <span className="text-size-14">Destinatário:</span>
        <span className="text-size-14">{recipient}</span>
      </div>
      <div className="flex justify-between">
        <span className="text-size-14">Data:</span>
        <span className="text-size-14">{date}</span>
      </div>
    </div>
  );
};

export default CardDetails;



